import { AnalyticsEvent } from '../models';
import { WebInteraction } from '../platforms/adobe-analytics/models';

export class LinkClickEvent implements AnalyticsEvent {
  name = 'LinkClickEvent';

  constructor(public readonly webInteraction: WebInteraction) {}
}
